//检测JWT是否过期
// tokenStatus.js

export function isTokenExpired(token) {
    if (!token) {
        return true; // 如果token不存在，则认为它已经过期
    }

    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const { exp } = JSON.parse(jsonPayload);
        const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间（以秒为单位）

        return currentTime > exp;
    } catch (error) {
        return true; // 如果解析JWT时出错，则认为它已经过期
    }
}

//获取用户Id
export function getUserIdFromToken(token) {
    if (!token) {
      return null; // 如果token不存在，则返回null
    }
  
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
  
      const { id } = JSON.parse(jsonPayload); // 从JWT中提取用户ID
      return id;
    } catch (error) {
      return null; // 如果解析JWT时出错，则返回null
    }
  }

  //获取用户用户名
export function getUserNameFromToken(token) {
  if (!token) {
    return null; // 如果token不存在，则返回null
  }

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const { UserName  } = JSON.parse(jsonPayload); // 从JWT中提取用户ID
    return UserName ;
  } catch (error) {
    return null; // 如果解析JWT时出错，则返回null
  }
}

export function getTokenFromLocalStorage() {
    return localStorage.getItem('token');
}

export function removeTokenFromLocalStorage() {
    localStorage.removeItem('token');
}